import StaticPage from '../components/StaticPage';
import Link from 'next/link';
import React, {useEffect} from 'react';
import {NextSeo} from 'next-seo';

export const title = 'Privacy Policy';

export default function PrivacyPolicy() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://app.termly.io/embed-policy.min.js';
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <>
      <NextSeo title="Privacy Policy | Polar Signals" />
      <StaticPage
        title={title}
        subTitle={
          <>
            Your Privacy Rights
            <br />
            [CA residents: <Link href="/ccpa">CCPA</Link>]
          </>
        }
      >
        <div
          // @ts-expect-error
          name="termly-embed"
          data-id="a512c5b3-1092-4ea1-a244-a5fee09cffbb"
          data-type="iframe"
        ></div>
      </StaticPage>
    </>
  );
}
